import {useEffect, useState} from 'react';
import {Col} from 'react-bootstrap';
import {LuLayoutDashboard, LuBox, LuShoppingCart, LuSettings, LuLogOut} from 'react-icons/lu';
import {GoSync} from 'react-icons/go';
import {MdOutlinePaid} from 'react-icons/md';

const LeftSidebar = (props)=>{
  const [currentMenu, setCurrentMenu] = useState('');

  useEffect(() => {
    const {pathname} = window.location;
    const paths = pathname.split('/');

    setCurrentMenu(paths[3] || 'dashboard');
  }, []);

  return (
    <>
      <Col className={`col-2 left-sidebar ${props?.isBarOpen ? 'opened' : 'closed'}`}>
        <div>
          <h1 className='left-app-name text-center'><LuShoppingCart size={'40px'} /> EPP</h1>

          <div className="menu-wrapper">
            <a href={`${process.env.PUBLIC_URL}/back-office/dashboard`}>
              <div className={`item d-flex align-items-center ${(currentMenu == 'dashboard') && 'active'}`}>
                <LuLayoutDashboard size={'24px'} className='me-2' /> Dashboard
              </div>
            </a>
            <a href={`${process.env.PUBLIC_URL}/back-office/product`}>
              <div className={`item d-flex align-items-center ${currentMenu == 'product' && 'active'}`}>
                <LuBox size={'24px'} className='me-2' /> Products
              </div>
            </a>
            <a href={`${process.env.PUBLIC_URL}/back-office/sale-order`}>
              <div className={`item d-flex align-items-center ${currentMenu == 'sale-order' && 'active'}`}>
                <LuShoppingCart size={'24px'} className='me-2' /> Sales Orders
              </div>
            </a>
            <a href={`${process.env.PUBLIC_URL}/back-office/paid-orders`}>
              <div className={`item d-flex align-items-center ${currentMenu == 'paid-orders' && 'active'}`}>
                <MdOutlinePaid size={'24px'} className='me-2' /> Paid Orders
              </div>
            </a>
            <a href={`${process.env.PUBLIC_URL}/back-office/sync-logs`}>
              <div className={`item d-flex align-items-center ${currentMenu == 'sync-logs' && 'active'}`}>
                <GoSync size={'22px'} className='me-2' /> Sync Logs
              </div>
            </a>
            <a href={`${process.env.PUBLIC_URL}/back-office/settings`}>
              <div className={`item d-flex align-items-center ${currentMenu == 'settings' && 'active'}`}>
                <LuSettings size={'24px'} className='me-2' /> Settings
              </div>
            </a>
            <div className='item d-flex align-items-center' onClick={() => window.location.href = process.env.PUBLIC_URL + '/back-office/logout'}>
              <LuLogOut size={'24px'} className='me-2' /> Logout
            </div>
          </div>
        </div>

      </Col>
    </>
  );
};

export default LeftSidebar;
